import { Button } from '@blueprintjs/core';
import { useState } from 'react';
import { useQueryClient } from 'react-query';
import {
  applicationKeys,
  customerKeys,
  personKeys,
} from '@axo/shared/data-access/hooks';

export function RefreshApplicationButton({
  applicationID,
  customerID,
  personID,
}: {
  applicationID: string;
  customerID?: string;
  personID?: string | null;
}) {
  const client = useQueryClient();
  const [isRefetching, setIsRefetching] = useState(false);
  const applicationCacheKey = applicationKeys.root({
    applicationID,
  });
  const customerCacheKey = customerKeys.root({
    customerID,
  });
  const personCacheKey = personKeys.root({
    personID,
  });

  return (
    <Button
      icon="refresh"
      loading={isRefetching}
      onClick={async () => {
        const promises = [client.invalidateQueries(applicationCacheKey)];
        if (customerID) {
          promises.push(client.invalidateQueries(customerCacheKey));
        }
        if (personID) {
          promises.push(client.invalidateQueries(personCacheKey));
        }
        setIsRefetching(true);
        try {
          await Promise.all(promises);
        } finally {
          setIsRefetching(false);
        }
      }}
    />
  );
}
